import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const usePrevious = (props) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = props;
  });
  return ref.current;
};

usePrevious.propTypes = {};

usePrevious.defaultProps = {};

export default usePrevious;
